import React, { useEffect, useRef } from 'react';
import Tools from '../../cvp-webgames-core/Misc/Tools';
import { BaseConfig } from '../BaseConfig';

import "./pop-up1.css"
import Button1, { Button1Config } from './button1';
import { PreCacheItem, SinglePreCacheItem, PrecacheItemType } from '../../cvp-webgames-core/pre-caching/pre-cache-item';
import { constants } from '../../misc/constants';

class PopUp1Caching extends PreCacheItem {
	public getItems(): SinglePreCacheItem[] {
		return [
			{
				type: PrecacheItemType.Image,
				key: 'logo',
				src: process.env.PUBLIC_URL + '/assets/images/main-menu/logo.png'
			}
		];
	}
}

export const popUp1Caching = new PopUp1Caching();

const PopUp1 = (props: PopUp1Config) => {
	const root = useRef(null);
	useEffect(() => {
		if(props.onUpdateRoot) {
			props.onUpdateRoot(root);
		}
	}, [root])
	return (
		<div>
			{props.mainMenu ? (
				<div ref={root} className={`modal-disable-select center-element main-content pop-up1-container2 ${props.rootClass}`} style={{
					...props.rootStyle
				}}>
					<div className='pop-up1-row2'>
						<img className={`pop-up1-logo2 center-element-horizontal ${constants.mainContent508Id}`} src={popUp1Caching.getItemByKey('logo').src} alt={'Boundary Settings Simulation Logo'} aria-label={'Boundary Settings Simulation Logo'}/>
					</div>

					<div className='pop-up1-description2 pop-up1-row2' style={{marginBottom: '10px'}}>
						{props.onRenderContent()}
					</div>

					<div className='pop-up1-buttons-container'>
						{props.buttons.map((buttonProps: Button1Config, i: number) => {
							return (
								<div key={Tools.generateGuid()} style={{marginBottom: '10px'}}>
									<Button1 props={buttonProps}></Button1>
								</div>
							);
						})}
					</div>

					<div className='pop-up1-description2 pop-up1-row2' style={{marginBottom: '10px'}}>
						{props.onRenderContent2()}
					</div>
				</div>
			) : (
				<div className="modal-disable-select main-content add-pad add-marg">
					<div className='pop-up1-row' style={{height: '180px'}}>
						<img className={`pop-up1-logo center-element ${constants.mainContent508Id}`} src={popUp1Caching.getItemByKey('logo').src} alt={'Boundary Settings Simulation Logo'} aria-label={'Boundary Settings Simulation Logo'}/>
					</div>

					<div className='pop-up1-description pop-up1-row' style={{marginBottom: '10px'}}>
						{props.onRenderContent()}
					</div>

					<div className='pop-up1-buttons-container black-text'>
						{props.buttons.map((buttonProps: Button1Config, i: number) => {
							return (
								<div key={Tools.generateGuid()} style={{marginBottom: '10px'}}>
									<Button1 props={buttonProps}></Button1>
								</div>
							);
						})}
					</div>
				</div>
			)}
		</div>
	);

};

export interface PopUp1Config extends BaseConfig {
	title: string;
	onRenderContent: () => any;
	onUpdateRoot?: (root: any) => any;
	onRenderContent2?: () => any;
	buttons: Button1Config[];
	mainMenu?: boolean;
	rootStyle?: any;
	rootClass?: any;
}

export default PopUp1;